import axios from "axios";

const USER_LOGIN_URL = "api/login";
const USER_LOGOUT_URL = "api/logout";
const USER_RENEW_URL = "api/renew";

export default {
  login,
  logout,
  renew
};

function login(username, password, token) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(USER_LOGIN_URL, {
        user_name: username,
        code: password,
        token: token
      });
      if (
        typeof response.data.data.name !== "undefined" &&
        typeof response.data.data.expiresAt !== "undefined"
      ) {
        localStorage.setItem("name", response.data.data.name);
        localStorage.setItem("loginExpiresAt", response.data.data.expiresAt);
        resolve(response.data.data);
      } else {
        reject("name or expiresAt is not defined");
      }
    } catch (e) {
      reject(e);
    }
  });
}

function logout(expired = false) {
  return new Promise(async (resolve, reject) => {
    if (expired === true) {
      removeItemsFromStorage();
      resolve("Auto logout");
    } else {
      try {
        const response = await axios.post(USER_LOGOUT_URL);
        removeItemsFromStorage();
        resolve(response.data);
      } catch (e) {
        reject(e);
      }
    }
  });
}

// returns new expiration date from server
function renew() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(USER_RENEW_URL);
      if (typeof response.data.data.expiresAt !== "undefined") {
        localStorage.setItem("loginExpiresAt", response.data.data.expiresAt);
        resolve(response.data.data.expiresAt);
      } else {
        reject("expiresAt is undefined");
      }
    } catch (e) {
      reject(e);
    }
  });
}

function removeItemsFromStorage() {
  localStorage.removeItem("loginExpiresAt");
  localStorage.removeItem("name");
}
